import { FormInstance } from "antd";
import React, { useEffect, useMemo } from "react";

const useSetHours = (form: FormInstance, isUpdatingStore: Boolean) => {
  const OpeningHoursForm = [
    {
      title: "Monday",
      openName: "openingHoursMon",
      closeName: "closingHoursMon",
      breakStartName: "breakingStartHourMon",
      breakEndName: "breakingEndHourMon",
      offName: "offMon",
      type: "time",
    },
    {
      title: "Tuesday",
      openName: "openingHoursTue",
      closeName: "closingHoursTue",
      breakStartName: "breakingStartHourTue",
      breakEndName: "breakingEndHourTue",
      offName: "offTue",
      type: "time",
    },
    {
      title: "Wednesday",
      openName: "openingHoursWed",
      closeName: "closingHoursWed",
      breakStartName: "breakingStartHourWed",
      breakEndName: "breakingEndHourWed",
      offName: "offWed",
      type: "time",
    },
    {
      title: "Thursday",
      openName: "openingHoursThu",
      closeName: "closingHoursThu",
      breakStartName: "breakingStartHourThu",
      breakEndName: "breakingEndHourThu",
      offName: "offThu",
      type: "time",
    },
    {
      title: "Friday",
      openName: "openingHoursFri",
      closeName: "closingHoursFri",
      breakStartName: "breakingStartHourFri",
      breakEndName: "breakingEndHourFri",
      offName: "offFri",
      type: "time",
    },
    {
      title: "Saturday",
      openName: "openingHoursSat",
      closeName: "closingHoursSat",
      breakStartName: "breakingStartHourSat",
      breakEndName: "breakingEndHourSat",
      offName: "offSat",
      type: "time",
    },
    {
      title: "Sunday",
      openName: "openingHoursSun",
      closeName: "closingHoursSun",
      breakStartName: "breakingStartHourSun",
      breakEndName: "breakingEndHourSun",
      offName: "offSun",
      type: "time",
    },
  ];
  const [trigger, setTrigger] = React.useState<boolean>(false);
  const [listOpeningHours, setListOpeningHours] = React.useState<boolean[]>([true, true, true, true, true, true, true]);
  const [listBreakingHours, setListBreakingHours] = React.useState<boolean[]>([
    true,
    true,
    true,
    true,
    true,
    true,
    true,
  ]);
  const [isInside, setIsInside] = React.useState(false);
  function handleSetListOpeningHours() {
    const listOpeningHours = OpeningHoursForm.map((item, index) => {
      if (form.getFieldValue(item.openName) && form.getFieldValue(item.closeName)) {
        return true;
      } else {
        return false;
      }
    });

    const listBreakingHours = OpeningHoursForm.map((item, index) => {
      if (!form.getFieldValue(item.breakStartName) && !form.getFieldValue(item.breakEndName)) {
        return true;
      } else {
        return false;
      }
    });

    setListBreakingHours(listBreakingHours);
    setListOpeningHours(listOpeningHours);
  }

  function handleSetBreakSchedule(idx: number) {
    setListBreakingHours(prev => {
      const newList = [...prev];
      newList[idx] = !newList[idx];
      return newList;
    });
  }

  function handleSetDaysSchedule(idx: number) {
    setListOpeningHours(prev => {
      const newList = [...prev];
      newList[idx] = !newList[idx];
      return newList;
    });
  }

  function handleSetBreakScheduleStatus(idx: number, status: boolean) {
    setListBreakingHours(prev => {
      const newList = [...prev];
      newList[idx] = status;
      return newList;
    });
  }

  function isCurrentDayHaveOpen(idx: number) {
    const currentDayHaveOpen = form.getFieldsValue([OpeningHoursForm[idx].openName, OpeningHoursForm[idx].closeName]);
    if (!currentDayHaveOpen[OpeningHoursForm[idx].openName] || !currentDayHaveOpen[OpeningHoursForm[idx].closeName]) {
      return false;
    }

    return true;
  }

  function isCurrentDayHaveBreak(idx: number) {
    const currentDayHaveBreak = form.getFieldsValue([
      OpeningHoursForm[idx].breakStartName,
      OpeningHoursForm[idx].breakEndName,
    ]);
    if (
      !currentDayHaveBreak[OpeningHoursForm[idx].breakStartName] ||
      !currentDayHaveBreak[OpeningHoursForm[idx].breakEndName]
    ) {
      return false;
    }

    return true;
  }

  function handleDuplicate(idx: number) {
    const currentDayHaveOpen = form.getFieldsValue([OpeningHoursForm[idx].openName, OpeningHoursForm[idx].closeName]);
    const currentDayHaveBreak = form.getFieldsValue([
      OpeningHoursForm[idx].breakEndName,
      OpeningHoursForm[idx].breakStartName,
    ]);

    if (isCurrentDayHaveOpen(idx)) {
      setListOpeningHours([true, true, true, true, true, true, true]);
      OpeningHoursForm.forEach((item, index) => {
        if (index !== idx) {
          form.setFieldsValue({
            [item.openName]: currentDayHaveOpen[OpeningHoursForm[idx].openName],
            [item.closeName]: currentDayHaveOpen[OpeningHoursForm[idx].closeName],
          });
        }
      });
    }

    if (
      currentDayHaveBreak[OpeningHoursForm[idx].breakEndName] ||
      currentDayHaveBreak[OpeningHoursForm[idx].breakStartName]
    ) {
      setListBreakingHours([false, false, false, false, false, false, false]);
    }
    OpeningHoursForm.forEach((item, index) => {
      if (index !== idx) {
        form.setFieldsValue({
          [item.breakStartName]: currentDayHaveBreak[OpeningHoursForm[idx].breakStartName] ?? undefined,
          [item.breakEndName]: currentDayHaveBreak[OpeningHoursForm[idx].breakEndName] ?? undefined,
        });
      }
    });
  }

  const listDaysHaveOpen = useMemo(() => {
    return OpeningHoursForm.map((item, idx) => {
      return isCurrentDayHaveOpen(idx);
    });
  }, [trigger]);

  const listDaysHaveBreak = useMemo(() => {
    return OpeningHoursForm.map((item, idx) => {
      return isCurrentDayHaveBreak(idx);
    });
  }, [trigger]);

  useEffect(() => {
    if (isUpdatingStore) {
      handleSetListOpeningHours();
    }
  }, [isUpdatingStore]);
  return {
    listOpeningHours,
    handleSetDaysSchedule,
    handleSetBreakSchedule,
    OpeningHoursForm,
    handleDuplicate,
    setTrigger,
    trigger,
    listDaysHaveOpen,
    listBreakingHours,
    listDaysHaveBreak,
    isInside,
    setIsInside,
    handleSetBreakScheduleStatus,
  };
};

export default useSetHours;
